import * as Yup from 'yup'
import { CONFIG, SAVE } from 'capacity/copy'
import { CapacityDetails, countingTypeFromWire, LIMIT_MAX, parseLimitInput, toLimitState } from 'capacity/types'
import { CapacityBaseline, CapacityFormValues } from 'capacity/staging/savePlan'

export const NAME_MAX = 500

export const capacityFormSchema = Yup.object().shape({
    name: Yup.string().trim().required(SAVE.nameMissing).max(NAME_MAX),
    limit: Yup.string().test('limit', CONFIG.limitInvalid, (value) => parseLimitInput(value ?? '') !== 'invalid'),
    countingType: Yup.mixed<'wholeTimeSlot' | 'arrivalOnly'>().oneOf(['wholeTimeSlot', 'arrivalOnly']).required(),
})

export const NEW_CAPACITY_VALUES: CapacityFormValues = { name: '', limit: '', countingType: 'wholeTimeSlot' }

export const limitToInput = (defaultAvailability: number | null | undefined): string =>
    defaultAvailability === null || defaultAvailability === undefined ? '' : String(defaultAvailability)

export const capacityToFormValues = (capacity: CapacityDetails | undefined): CapacityFormValues =>
    capacity
        ? {
              name: capacity.name,
              limit: limitToInput(capacity.defaultAvailability),
              countingType: countingTypeFromWire(capacity.reservationPeriodType),
          }
        : NEW_CAPACITY_VALUES

export const capacityToBaseline = (capacity: CapacityDetails | undefined): CapacityBaseline =>
    capacity
        ? {
              record: capacity,
              name: capacity.name,
              limit: toLimitState(capacity.defaultAvailability),
              countingType: countingTypeFromWire(capacity.reservationPeriodType),
          }
        : { record: null, name: '', limit: { kind: 'noLimit' }, countingType: 'wholeTimeSlot' }

export { LIMIT_MAX }
